import React, { useEffect, useState } from 'react';

import PlanCard from './PlanCard';
import { CoachAPI } from '../../../api/CoachAPI';
import SecondLoader from '../../../component/SecondLoader';
import { SubscriptionAPI } from '../../../api/SubscriptionAPI';
import { useSelector } from 'react-redux';
import { PaymentAPI } from '../../../api/PaymentAPI';
import Loader from '../../../component/Loader';
import SubDetailsCard from './SubDetailsCard';
import { useDispatch } from 'react-redux';
import { rootAction } from '../../../redux/reducer/rootReducer';

const PlatformCoachPlans = ({ setSubscriptionStatus, setIsUpdated, updateCalenderType }) => {
  const userInfo = useSelector((state) => state.user.userInfo);
  const selectedClub = useSelector((state) => state.user.selectedClub);
  const dispatch=useDispatch();
  const [plans, setPlans] = useState([]);
  const [subscriptionDetails, setSubscriptionDetails] = useState({});
  const [isRefresh, setIsRefresh] = useState(false);
  const [defaultPayCard, setDefaultPayCard] = useState(null);
  const [loadingState, setLoadingState] = useState({
    loading1: false,
    loading2: false,
    loading3: false,
  });

  const startLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: true
    }))
  };

  const finishLoading = (key) => {
    setLoadingState((prev) => ({
      ...prev,
      [key]: false
    }))
  };

  const fetchAllCoachPlans = async () => {
    try {
      startLoading("loading1")
      const response = await CoachAPI.getAllPlatformProducts();
      setPlans(response.Data);
      finishLoading("loading1");
    } catch (error) {
      finishLoading("loading1");
    }
  }
  const findSubscription = async () => {
    try {
      startLoading('loading2');
      const subscriptionInfo = await SubscriptionAPI.findSubscription(selectedClub.clubId);
     
      setSubscriptionDetails(subscriptionInfo.Data);
      if (typeof setSubscriptionStatus === 'function') {
        setSubscriptionStatus(subscriptionInfo.Data?.status);
      }
      finishLoading("loading2");
    } catch (error) {
      console.error(error);
      finishLoading("loading2");
    }
  };
  const fetchDefaultPaymentMethodData = async () => {
    try {
      const defaultPaymentMethod = await PaymentAPI.fetchDefaultPaymentMethodData(userInfo?.userId, selectedClub.clubId);
      setDefaultPayCard(defaultPaymentMethod.Data)
    } catch (error) {
      console.error(error);
    }
  };

  const resumeSubscription = async () => {
    try {
      startLoading("loading3")
      const subUpateInfo = {
        subscriptionId: subscriptionDetails?.subscriptionStripeId
      }
      const result = await SubscriptionAPI.resumeSubscription(subUpateInfo);
      setTimeout(() => {
        setIsRefresh(true);
        dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'success', content: 'Your subscription is resumed successfully' }));
      }, 1000);
      finishLoading("loading3");
    } catch (error) {
      console.error(error);
      finishLoading("loading3");
      dispatch(rootAction.setWarningMessage({ id: Date.now(), type: 'error', content: 'Something went wrong' }));
    }
  }
  useEffect(() => {
    fetchAllCoachPlans();
    findSubscription();
    if (subscriptionDetails) {
      fetchDefaultPaymentMethodData();
    }
    isRefresh && setIsRefresh(false);
  }, [isRefresh])


  if (loadingState.loading1 || loadingState.loading2) {
    return <SecondLoader />
  }
  return (
    <div className='coach_paln_detals_container'>
      {loadingState.loading3 && <Loader />}
      {subscriptionDetails?.status &&
        <SubDetailsCard
          subscriptionDetails={subscriptionDetails}
          defaultPayCard={defaultPayCard}
          selectedClub={selectedClub}
          resumeSubscription={resumeSubscription}
        />
      }

      {!subscriptionDetails &&
        <div className='manage_coach_sub_price_details'>
          {
            plans?.map((plan, index) => (
              <PlanCard key={index} planInfo={plan} setIsRefresh={setIsRefresh} updateCalenderType={updateCalenderType} />
            ))
          }
        </div>}
    </div>
  )
}

export default PlatformCoachPlans